export const environment = {
    production: false,
    host: "https://dev.saintex.dmedia.ma",
    apiHost: "https://dev.saintex.dmedia.ma",
    api: "https://dev.saintex.dmedia.ma/api",
    fullCalendarLicense: "CC-Attribution-NonCommercial-NoDerivatives",
    // deepcode ignore HardcodedNonCryptoSecret: <please specify a reason of ignoring this>
    strPmtPK: "pk_test_51OkF0rCLZRUdhBNpgB4nmm3Lvz3Ty06wEHTYGtpK2KZ0An6WQqI1H67A4xVKnau5otV5KZwwDTrTuhQIARVHlnTR00Ykd9UZS9"
};